import { TextNewProps } from '@jfs/ui-new'

export const styles = {
  titleText: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
    textAlign: 'center',
  } as TextNewProps,
}
